<script>
    import ModalEdit from '../../../layouts/ModalEdit.vue';
    import componentStock from "../../../components/Stock.vue";
    import ProductOptionService from "../option/ProductOptionService";

    export default {
        components:{
            componentStock
        },
        extends: ModalEdit,
        name: 'modal',
        props: ['value','visible'],
        data: function () {
            return {
              selling_price: null,
              cost_price:null,
                config: null,
                internalValue: '',
                currency: '',
                genders: [
                    {id:'unisex', name:'Unisex'},
                    {id:'male', name:'Monsieur'},
                    {id:'female', name:'Madame'}
                ]
            }
        },
        mounted: function(){
            this.currency = this.$store.state.scope.currency_id
          this.selling_price = 'Prix de vente ' + (this.$store.state.scope.is_ttc?'TTC':'HT')
          this.cost_price = 'Prix de revient ' + (this.$store.state.scope.is_ttc?'TTC':'HT')
        },
        created: function() {
            this.internalValue = this.value;

          for(let gender of this.genders){
            if( gender.id == this.internalValue.gender ){
              this.internalValue.gender = gender
              break;
            }
          }

            this.initialize();
        },
        methods: {
            close() {
                this.$emit('close');
            },
            validate(){
                this.$emit('validate');
            },
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
            }
        }
    };
</script>
<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" v-bind:class="className">
            <div class="modal-overlay" @click="close()"></div>
            <div class="modal"
                 role="dialog"
                 aria-labelledby="modalTitle"
                 aria-describedby="modalDescription">
                <article v-if="internalValue && internalValue">
                    <header
                            class="modal-header"
                            id="modalTitle">
                        <figure><i class="icon icon-icon_file-edit"></i></figure>
                        <div>
                            <span class="breadcrumb">
                                Produit <i class="icon icon-icon_arrow-right"></i> Edit
                            </span>
                            <h1>Variante</h1>
                        </div>
                        <div class="spacer"></div>
                        <div class="buttons">
                            <button @click="close()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                            <button @click="validate()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                        </div>
                    </header>
                    <main>

                         <languages :translations="internalValue.translations" :localesLoaded="localesLoaded" :locales="locales" v-model="locale"></languages>

                        <tabs :options="{ useUrlFragment: false }">
                            <tab name="Information">

                                <form-number label="Ordre d'affichage" v-model="internalValue.ord" :step="1"></form-number>

                                <form-date label="Sortie du produit" v-model="internalValue.released_at" :toggleable="true"></form-date>

                              <form-number label="'Donation'" v-model="internalValue.amount_donation" :suffix="currency" :step="0.05" required="true"></form-number>
                              <form-number :label="cost_price" v-model="internalValue.amount_cost_price" :suffix="currency" :step="0.05" required="true"></form-number>
                                <form-number :label="selling_price" v-model="internalValue.amount_selling_price" :suffix="currency" :step="0.05" required="true"></form-number>

                                <form-text label="SKU" v-model="internalValue.sku"></form-text>
                                <form-text :label="'SKU fournisseur'" v-model="internalValue.sku_supplier"></form-text>

                                <form-text label="EAN" v-model="internalValue.ean"></form-text>

                                <form-select label="Gender" multiple="false" v-model="internalValue.gender" :default="this.internalValue.gender" :options="genders"></form-select>

                                <form-text label="Groupe" v-model="internalValue.group"></form-text>
                                <form-select label="Options" multiple="false" :default="internalValue.option_behavior_id" v-model="internalValue.option_behavior" :options="internalValue.option_behaviors" v-if="internalValue.option_behaviors"></form-select>

                            </tab>
                            <tab name="Contenu">

                                <form-gallery label="" v-model="internalValue.medias" width="200"></form-gallery>

                                <form-color-picker label="Couleur" v-model="internalValue.color"></form-color-picker>

                                <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                  <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                    <form-text :lang="client.id" :label="'Nom'" :translate-key="'name'" v-model="internalValue.translations[client.id].name" :translations="internalValue.translations" required="true"></form-text>
                                  </div>
                                </div>

                              <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                  <form-text :lang="client.id" :label="'Headline'" :translate-key="'headline'" v-model="internalValue.translations[client.id].headline" :translations="internalValue.translations" required="true"></form-text>
                                </div>
                              </div>

                                <tabs :options="{ useUrlFragment: false }">
                                    <tab name="Description">

                                      <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                        <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                          <form-html :lang="client.id" :label="'description'" :translate-key="'description'" v-model="internalValue.translations[client.id].description" :translations="internalValue.translations" required="true"></form-html>
                                        </div>
                                      </div>

                                    </tab>
                                    <tab name="Complement">

                                      <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                        <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                          <form-html :lang="client.id" :label="'complement'" :translate-key="'complement'" v-model="internalValue.translations[client.id].complement" :translations="internalValue.translations" required="true"></form-html>
                                        </div>
                                      </div>

                                    </tab>
                                    <tab name="Composition">

                                      <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                        <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                          <form-html :lang="client.id" :label="'composition'" :translate-key="'composition'" v-model="internalValue.translations[client.id].composition" :translations="internalValue.translations" required="true"></form-html>
                                        </div>
                                      </div>


                                    </tab>
                                    <tab name="Notice">

                                      <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                        <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                          <form-html :lang="client.id" :label="'notice'" :translate-key="'notice'" v-model="internalValue.translations[client.id].notice" :translations="internalValue.translations" required="true"></form-html>
                                        </div>
                                      </div>

                                    </tab>
                                </tabs>


                            </tab>
                            <tab name="Packaging">

                                <fieldset>
                                    <h3>Stock</h3>
                                  <p class="headline"></p>

                                    <form-numeric :label="'Déduction du stock'" v-model="internalValue.stock_quantity_out" default="1"></form-numeric>
                                    <form-toggle label="Illimité" v-model="internalValue.unlimited_stock"></form-toggle>
                                    <component-stock v-model="internalValue.stock.inventories" v-if="!internalValue.unlimited_stock"></component-stock>

                                </fieldset>

                            </tab>
                        </tabs>

                    </main>
                </article>
            </div>
        </div>
    </transition>
</template>


// WEBPACK FOOTER //
// src/modules/shop/product/Modal.vue